module.exports = __webpack_public_path__ + "img/graphicstablet.jpg.7540a269.webp";